export default __webpack_public_path__ + "static/media/trading.0c6e01eb.png";